import script from "./ImpersonationPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ImpersonationPanel.vue?vue&type=script&setup=true&lang=js"

import "./ImpersonationPanel.vue?vue&type=style&index=0&id=645a5915&lang=scss"

const __exports__ = script;

export default __exports__